export const META_PIXEL_ID = '2518019921972507';

interface FbqWindow extends Window {
  fbq?: ((...args: unknown[]) => void) & {
    callMethod?: (...args: unknown[]) => void;
    queue?: unknown[][];
    push?: unknown;
    loaded?: boolean;
    version?: string;
  };
  _fbq?: unknown;
}

function getWindow(): FbqWindow | null {
  return typeof window === 'undefined' ? null : (window as FbqWindow);
}

export function initMetaPixel(): void {
  const win = getWindow();
  if (!win || win.fbq) return;

  const fbq = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
    } else {
      fbq.queue?.push(args);
    }
  } as NonNullable<FbqWindow['fbq']>;

  fbq.queue = [];
  fbq.loaded = true;
  fbq.version = '2.0';
  win.fbq = fbq;
  win._fbq = fbq;

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);

  const noscript = document.createElement('noscript');
  const pixelImg = document.createElement('img');
  pixelImg.height = 1;
  pixelImg.width = 1;
  pixelImg.style.display = 'none';
  pixelImg.alt = '';
  pixelImg.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`;
  noscript.appendChild(pixelImg);
  document.body.appendChild(noscript);

  win.fbq('init', META_PIXEL_ID);
  win.fbq('track', 'PageView');
}

export function trackPixelEvent(event: string, params?: Record<string, unknown>): void {
  const win = getWindow();
  win?.fbq?.('track', event, params);
}
